import React from "react";
import ServicePage from "../components/ServicePage";
function ManagedITSupportPage() {
	const title = "AI Enablement Framework";

	const content = {
		title: "TURN CURIOSITY INTO CAPABILITY",
		paragraphs: [
			"Artificial intelligence is no longer just for tech giants. Yet many small and midsize business leaders remain unsure where to start. In fact, 62% of SMB owners admit they don't know how AI fits into their business, often assuming it is too complex or reserved for large enterprises. This uncertainty leads to hesitation at a time when competitors are already experimenting and gaining efficiencies. Cost is another common barrier: 55% of SMB owners say budget concerns hold them back from exploring AI, even though many solutions now scale affordably to smaller teams. Beyond the financial side, there are human factors. A quarter of SMB leaders worry their teams aren't ready for AI, fearing a lack of skills or resistance to change. Over 40% believe they'll need to hire experts they can't easily find or afford, creating a perception that AI adoption is out of reach. These challenges are real, but they are also solvable. With the right guidance, SMBs can cut through the noise, identify practical entry points, and empower their people to build AI confidence. Curiosity is the first step-capability is what follows when strategy, tools, and training come together.",
		],
		mainOffer: {
			title: "AI is more than ChatGPT",
			description:
				"Every month without AI widens the gap with your competition. AI is doing for businesses what the internet did 30 years ago; practical, affordable, and essential. Early adopters are already seeing top- and bottom-line results:",
			bulletPoints: [
				"Revenue Growth: 91% of SMBs say AI boosts revenue while 90% report greater efficiency.",
				"Monthly Cost Savings: 66% of SMBs report AI saves their business between $500 - $2,000 monthly.",
				"Customer Outcomes: 91% of SMBs report better customer experience via faster support & personalized service.",
				"Employee Expereince: Daily AI users report 64% higher productivity, 58% greater focus, and 81 % more job satisfaction",
			],
			illustration: "/images/illustrations/ai-variety-of-opportunities-to-leverage-ai.png",
		},
	};

	const services = [
		{
			title: "Discover",
			description:
				"We help organizations uncover where AI can create the most value. Our AI Readiness Assessment identifies current capabilities and gaps, while AI Opportunity Discovery reveals practical use cases that align with business goals. Together, these steps build a clear foundation for adopting AI with confidence and measurable impact.",
		},
		{
			title: "Implement",
			description:
				"Turning opportunity into action requires the right tools and strategy. We guide you through AI Tool Evaluation and Selection to match technology with business needs, and design prompts that deliver accurate, useful results. Our team ensures each implementation is practical, secure, and tailored to your organization's priorities."
		},
		{
			title: "Optimize",
			description:
				"Adopting AI is more than technology, it is about people and processes. We support Change Management and Adoption Planning, provide Employee Training and Enablement, and deliver ongoing optimization. Our approach ensures AI tools are embraced across teams, consistently deliver value, and evolve alongside your business needs.",
		},
	];

	return <ServicePage title={title} content={content} services={services} />;
}

export default ManagedITSupportPage;
